// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const AllBlog = () => {
//     const [blogs, setBlogs] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         fetchBlogs();
//     }, []);

//     const fetchBlogs = async () => {
//         try {
//             const response = await axios.get('https://api.sofiasurgicals.com/api/get-all-blog');
//             setBlogs(response?.data);
//         } catch (error) {
//             console.error("Error fetching blogs:", error);
//             toast.error("Failed to load blogs");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (!window.confirm("Are you sure you want to delete this blog?")) return;

//         try {
//             await axios.delete(`https://api.sofiasurgicals.com/api/delete-blogs/${id}`);
//             setBlogs(prev => prev.filter(blog => blog._id !== id));
//             toast.success("Blog deleted successfully");
//         } catch (error) {
//             console.error("Error deleting blog:", error);
//             toast.error("Failed to delete blog");
//         }
//     };

//     return (
//         <>
//             <ToastContainer />
//             <div className="bread">
//                 <div className="head">
//                     <h4>All Blogs</h4>
//                 </div>
//                 <div className="links">
//                     <Link to="/add-blog" className="add-new">
//                         Add New <i className="fa-solid fa-plus"></i>
//                     </Link>
//                 </div>
//             </div>

//             <section className="mt-2 d-table table-responsive">
//                 <table className="table table-bordered table-striped table-hover">
//                     <thead>
//                         <tr>
//                             <th scope="col">S No</th>
//                             <th scope="col">Image</th>
//                             <th scope="col">Title</th>
//                             <th scope="col">Snippet</th>
//                             <th scope="col">Status</th>
//                             <th scope="col">Edit</th>
//                             <th scope="col">Delete</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr>
//                                 <td colSpan="7" className="text-center">Loading...</td>
//                             </tr>
//                         ) : blogs.length === 0 ? (
//                             <tr>
//                                 <td colSpan="7" className="text-center">No blogs found</td>
//                             </tr>
//                         ) : (
//                             blogs.map((blog, index) => (
//                                 <tr key={blog._id}>
//                                     <td>{index + 1}</td>
//                                     <td>
//                                         {blog.image ? (
//                                             <img
//                                                 src={`https://api.sofiasurgicals.com/${blog.image}`}
//                                                 alt={blog.title}
//                                                 width="60"
//                                                 height="60"
//                                                 style={{ objectFit: 'cover' }}
//                                             />
//                                         ) : "No Image"}
//                                     </td>
//                                     <td>{blog.title}</td>
//                                     <td>{blog.snippet}</td>
//                                     <td>{blog.status ? "Active" : "Inactive"}</td>
//                                     <td>
//                                         <Link to={`/edit-blog/${blog._id}`} className="bt edit">
//                                             Edit
//                                         </Link>
//                                     </td>
//                                     <td>
//                                         <button
//                                             onClick={() => handleDelete(blog?._id)}
//                                             className="bt delete"
//                                         >
//                                             Delete
//                                         </button>
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>
//             </section>
//         </>
//     );
// };

// export default AllBlog;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AllBlog = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const response = await axios.get('https://api.sofiasurgicals.com/api/get-all-blog');
            setBlogs(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error("Error fetching blogs:", error);
            toast.error("Failed to load blogs");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this blog?")) return;

        try {
            await axios.delete(`https://api.sofiasurgicals.com/api/delete-blogs/${id}`);
            setBlogs(prev => prev.filter(blog => blog._id !== id));
            toast.success("Blog deleted successfully");
        } catch (error) {
            console.error("Error deleting blog:", error);
            toast.error("Failed to delete blog");
        }
    };

    return (
        <>
            <ToastContainer />
            <div className="bread">
                <div className="head">
                    <h4>All Blogs</h4>
                </div>
                <div className="links">
                    <Link to="/add-blog" className="add-new">
                        Add New <i className="fa-solid fa-plus"></i>
                    </Link>
                </div>
            </div>

            <section className="mt-2 d-table table-responsive">
                <table className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">S No</th>
                            <th scope="col">Image</th>
                            <th scope="col">Title</th>
                            <th scope="col">Slug</th>
                            <th scope="col">Status</th>
                            <th scope="col">Edit</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="7" className="text-center">Loading...</td>
                            </tr>
                        ) : blogs.length === 0 ? (
                            <tr>
                                <td colSpan="7" className="text-center">No blogs found</td>
                            </tr>
                        ) : (
                            blogs.map((blog, index) => (
                                <tr key={blog._id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {blog.image ? (
                                            <img
                                                src={`https://api.sofiasurgicals.com/${blog.image}`}
                                                alt={blog.title}
                                                width="60"
                                                height="60"
                                                style={{ objectFit: 'cover' }}
                                            />
                                        ) : "No Image"}
                                    </td>
                                    <td>{blog.title}</td>
                                    <td><code>{blog.slug}</code></td>
                                    <td>{blog.status ? "Active" : "Inactive"}</td>
                                    <td>
                                        <Link to={`/edit-blog/${blog._id}`} className="bt edit">
                                            Edit
                                        </Link>
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => handleDelete(blog?._id)}
                                            className="bt delete"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </section>
        </>
    );
};

export default AllBlog;